<template>
  <div class="servicesWrap">
    <div class="profile-card">
      <div class="profile-header">
        <div class="avatar"><img src="https://h5.tc-rescue.com/snServices/images/icon_touxiang.png"></div>
        <div class="user-info"><h2>李烧烧</h2><p>13652***1253</p></div>
      </div>
      <div class="stats">
        <div class="stat-item"><div class="stat-value">5次</div><div class="stat-label">洗车</div></div>
        <div class="stat-item"><div class="stat-value">2次</div><div class="stat-label">保养</div></div>
        <div class="stat-item"><div class="stat-value">3次</div><div class="stat-label">代驾</div></div>
        <div class="stat-item"><div class="stat-value">0次</div><div class="stat-label">玻璃修复</div></div>
      </div>
    </div>
    <van-tabs :active="tabsOn" bind:change="onChange">
      <van-tab title="我的预约">
        <div class="list-item" v-for="(item,index) in list">
          <img :src="'https://h5.tc-rescue.com/snServices/images/m ('+ (index+1) +').jpg'" class="item-image">
          <div class="item-content">
            <div class="item-title">{{merchantList[index] ? merchantList[index].name : merchantList[1].name}}</div>
            <div class="item-desc">{{merchantList[index]? merchantList[index].address : merchantList[1].address}}</div>
            <div class="item-meta" v-if="item.json_data && item.json_data.bookDate">预约时间: {{item.json_data.bookDate}}</div>
          </div>
          <button class="item-button" @click="toUserDetail(item)">详情</button>
        </div>
      </van-tab>
<!--      <van-tab title="我的订单">-->
<!--        <p class="noData">暂无数据</p>-->
<!--      </van-tab>-->
<!--      <van-tab title="我的优惠券">-->
<!--        <p class="noData">暂无数据</p>-->
<!--      </van-tab>-->
    </van-tabs>
    <van-tabbar v-model:active="active">
      <van-tabbar-item name="home" icon="home-o" @click="$router.push({path: '/servicesIndex'})">首页</van-tabbar-item>
      <van-tabbar-item name="user" icon="friends-o">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import util from '@/utils';
import Data from '@/utils/data';
import { isWeiXin, isSafari } from '@/utils';
import { servicesList } from "@/apis/rescue";



export default {
    data(){
        return {
            active: "user",
            tabsOn: "我的预约",
            user_phone: localStorage.getItem('user_phone'),
            user_nick: localStorage.getItem('user_nick'),
            merchant_id: localStorage.getItem('merchant_id'),
            list:[],
            merchantList:[
              {id: '1', img: '', name: '壳牌鹏致（园洲镇鑫宝驾）', address: '园洲镇沙河大道69号', desc: "标准洗车，精致洗车，空调清洗，车内消毒" },
              {id: '2', img: '', name: '嘉实多（跨粤汽车服务中心）', address: '麦地南路2号金裕大厦5号商铺', desc: "标准洗车，精致洗车，汽车美容，保养维修"  },
              {id: '3', img: '', name: '美孚1号车养护（惠州卓金冠店）', address: '麦地南路2号金裕大厦5号商铺', desc: "汽车服务、保养服务、汽车喷漆、钣金、"  },
              {id: '4', img: '', name: '京东养车（陈江大道店）', address: '惠城区陈江街道陈江大道学塘排(三)小区A4房1楼', desc: "洗车、汽车打蜡、保养服务、汽车维修"  },
              {id: '5', img: '', name: '漆遇车坊', address: '惠泽大道5号178', desc: "空调清洗、小保养、大保养、换机油、换刹车油，换刹车片、漆面修复"  },
              {id: '6', img: '', name: '车起点美容养护中心', address: ' 惠城区陈江街道陈江大道北36号宝德科技工业园东南方向150米', desc: "洗车服务、保养服务、维修服务、美容服务"  },
              {id: '7', img: '', name: '信义汽车玻璃（惠州仲恺店）', address: '五一路惠州汽配称D7-1号', desc: "汽车玻璃修复"  },
              {id: '8', img: '', name: '途虎养车工场店（惠州仲恺平南店）', address: '惠城区惠环街道和畅西3路43号', desc: "洗车服务、保养服务、维修服务、美容服务"  },
              {id: '9', img: '', name: '福耀汽车玻璃（惠州仲恺大道店）', address: '五一大道19号', desc: " 普洗、精洗、汽车玻璃修复、玻璃贴膜"  },
              {id: '10', img: '', name: '保来利汽车维修服务中心（仲恺店）', address: '惠城区惠环街道康平路康城四季花园三期21栋1-5号商铺', desc: "洗车服务、保养服务、维修服务、美容服务、改装服务、其他服务"  },
              // {id: '11', img: '', name: '', address: '', desc: "标准洗车，精致洗车，空调清洗，车内消毒"  },
              // {id: '12', img: '', name: '', address: '', desc: "标准洗车，精致洗车，空调清洗，车内消毒"  },
            ],
        }
    },
    created(){
        this.userId = this.$route.query.id;
        this.getList();
    },
    mounted(){

    },
    methods: {
        getList(){
            let data = {
                page: 1,
                limit: 100,
                user_phone: this.user_phone
            }
            servicesList(data).then((res)=>{
                let resData = res.data.data;
                if(res.data.code == 1){
                  this.list = resData.data.data;
                  console.log(this.list)
                }else{
                  this.$toast(res.data.info? res.data.info:'系统错误');
                }
            })
        },
        onSubmit(){
            let that = this;
            let data = {
                ...this.form
            }
            if(data.rate_value <=0){
              this.$toast('请给师傅服务评分！');
              return
            }
            if(data.is_battery === '' ){
              this.$toast('请选择师傅是否给您销售汽车电池！');
              return
            }
            if(data.is_battery == 1 && data.is_aftersale === '' ){
              this.$toast('请选择师傅承诺给您电池售后服务！');
              return
            }
            this.submitLoading = true;
            orderEvaluate(data).then((res)=>{
                that.$toast(res.data.info);
                that.submitLoading = false;
            })
        },
        toUserDetail(row){
          this.$router.push({path: '/servicesUserDetail?id='+ row.order_id});
        },
        onConfirm(row){
          this.form.battery_date = row.text;
          this.showPicker = false;
        }
    }
}
</script>

<style lang='scss' scoped>

</style>
